import BaseEntity from '@/entity/BaseEntity';
import useAvailabilityService from '@/services/AvailabilityService';

export default class TempWorkerUnavailabilitiesEntity extends BaseEntity<IUnavailabilityModel> {
	get id () { return this.state.id; }
	get startDate () { return this.state.startDate; }
	set startDate (val) { this.state.startDate = val; }
	get endDate () { return this.state.endDate; }
	set endDate (val) { this.state.endDate = val; }

	async deleteUnavailabilityAsync () {
		await useAvailabilityService().deleteUnavailabilityAsync(this.id);
	}

	async addUnavailabilityAsync () {
		return await useAvailabilityService().addUnavailabilityAsync({
			startDate: this.startDate,
			endDate: this.endDate,
		});
	}
}
